import React, { useEffect, useState } from "react";
import { auth, db } from "../../firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { useUser } from "../../context/contextAPI";
import { Helmet } from "react-helmet";

function Parrainage() {
  const { user } = useUser();
  const [referrals, setReferrals] = useState([]);
  const [promoCode, setPromoCode] = useState("");

  const generatePromoCode = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let code = "ECO";
    for (let i = 0; i < 5; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
  };

  const addMonths = (date, months) => {
    const result = new Date(date);
    result.setMonth(result.getMonth() + months);
    return result;
  };

  useEffect(() => {
    const fetchReferrals = async () => {
      if (auth.currentUser) {
        const userDoc = await getDoc(doc(db, "Users", auth.currentUser.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const referralsArray = userDoc.data().referrals || [];
          const referralsDetails = await Promise.all(
            referralsArray.map(async (uid) => {
              const referralDoc = await getDoc(doc(db, "Users", uid));
              const referralData = referralDoc.data();
              // Fetch purchase data
              const purchasesQuery = query(
                collection(db, "payments"),
                where("userId", "==", uid)
              );
              const purchasesSnapshot = await getDocs(purchasesQuery);
              const totalSpent = purchasesSnapshot.docs.reduce(
                (total, doc) => total + doc.data().amount,
                0
              );
              return {
                ...referralData,
                totalSpent,
                dateCreated: convertTimestampToDate(referralData.dateCreated),
              };
            })
          );
          setReferrals(referralsDetails);

          const promoCode = userData.promoCode;
          if (promoCode) {
            const currentDate = new Date();
            if (promoCode.expiryDate.toDate() > currentDate) {
              setPromoCode(promoCode.code);
            } else {
              await setDoc(
                doc(db, "Users", auth.currentUser.uid),
                {
                  promoCode: null,
                },
                { merge: true }
              );
            }
          }
        }
      }
    };

    fetchReferrals();
  }, [auth.currentUser]);

  const convertTimestampToDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp.seconds * 1000);
    return date.toLocaleDateString("fr-FR");
  };

  useEffect(() => {
    const eligibleReferrals = referrals.filter(
      (referral) => referral.totalSpent > 3000
    );
    if (eligibleReferrals.length > 10 && !promoCode) {
      const code = generatePromoCode();
      const expireDate = addMonths(new Date(), 1);

      // Save promo code to user document
      setDoc(
        doc(db, "Users", auth.currentUser.uid),
        {
          promoCode: {
            code,
            expireDate,
          },
        },
        { merge: true }
      );

      setPromoCode(code);
    }
  }, [referrals, promoCode]);
  const referralLink = `${window.location.origin}/auth/inscription?ref=${user?.referralCode}`;

  return (
    <>
      <Helmet>
        <title>Parrainage</title>
      </Helmet>
      <h1 className="poppins-bold text-3xl md:text-5xl text-gray-900 text-center">
        Invitez vos amis
      </h1>
      <div className="mb-4 rounded px-1 py-1 sm:py-4 md:py-5 mt-5">
        <p className="text-gray-700 mb-4">
          Vous recevrez des promotions pour chaque achat effectué par les
          personnes que vous avez invitées.{" "}
          <span className="poppins-bold">
            Les revenus d'affiliation sont illimités et
          </span>{" "}
          inviter plusieurs personnes peut vous rapporter des promotions
          importantes.
        </p>

        <p className="text-gray-700 mb-4">
          Vous pouvez également utiliser notre section{" "}
          <span className="poppins-bold">Promotion de parrainage</span> pour
          obtenir des filleuls.
        </p>

        <h3 className="mt-7 text-sm sm:text-base md:text-lg poppins-bold text-center text-black py-2 md:py-3 underline">
          Programme de partenariat et obtention de codes promotionnels
        </h3>

        <p className="text-gray-700">
          Pour bénéficier d'un code promo, les utilisateurs doivent inviter
          leurs amis à s'inscrire sur notre plateforme en utilisant leur lien de
          parrainage unique disponible dans la section <span className="poppins-semibold">"Votre lien de
          parrainage"</span>. Un filleul est comptabilisé dès qu'il effectue un achat
          minimum de <span className="poppins-semibold">3000 MUR</span>. Seuls les filleuls ayant dépensé plus de 3000 MUR sont pris
          en compte pour l'attribution des codes promo. <br />
          Les utilisateurs doivent atteindre un nombre spécifique de filleuls éligibles pour débloquer
          des récompenses :
        </p>

        <div class="grid grid-cols-3 justify-center gap-x-3 mt-5">
          <div class="h-full rounded-lg mb-6 flex flex-col relative overflow-hidden shadow-xl border border-pink-400">
            <div class="text-sm sm:tex-base lg:text-lg text-center text-pink-600 poppins-bold mt-4 px-2 md:px-4">
              Achat de produit par 10 filleul
            </div>
            <div class="pt-4 px-4 flex rounded-lg items-center text-gray-900">
              <p className="text-xs md:text-sm lg:text-base text-center">
                Gagner une reduction de{" "}
                <span className="poppins-semibold">
                  20% sur votre prochain achat pendant 2 mois.
                </span>
              </p>
            </div>
          </div>

          <div class="h-full rounded-lg mb-6 flex flex-col relative overflow-hidden shadow-xl border border-pink-400">
            <div class="text-sm sm:tex-base lg:text-lg poppins-bold text-pink-600 mt-4 text-center px-2 md:px-4">
              Achat de produit par 20 filleul
            </div>
            <div class="pt-4 pl-4 pr-4 flex rounded-lg items-center text-gray-900">
              <p className="text-xs md:text-sm lg:text-base text-center">
                Gagner une reduction de{" "}
                <span className="poppins-semibold">
                  20% sur votre prochain achat pendant 6 mois.
                </span>
              </p>
            </div>
          </div>

          <div class="h-full rounded-lg mb-6 flex flex-col relative overflow-hidden shadow-xl border border-pink-400">
            <div class="text-sm sm:tex-base lg:text-lg poppins-bold text-black mt-4 text-center px-2 md:px-4">
              Achat de produit par 50 filleul
            </div>
            <div class="pt-4 px-4 flex rounded-lg items-center text-gray-900">
              <p className="text-xs md:text-sm lg:text-base text-center">
                Gagner une reduction de{" "}
                <span className="poppins-semibold">
                  20% sur votre prochain achat pendant un an.
                </span>
              </p>
            </div>
          </div>
        </div>

        <p className="text-gray-700 mt-5">
          Le code promo peut être utilisé lors du prochain achat en l'entrant au
          moment de la finalisation de l'achat.
        </p>

        {user && (
          <>
            <h4 className="poppins-semibold text-center mt-5 text-lg underline text-pink-600">
              Votre lien de parrainage:
            </h4>
            <div className="flex justify-center mt-2">
              <span className="py-2 px-8 bg-white text-gray-700 text-sm sm:text-base">
                {referralLink}
              </span>
            </div>
          </>
        )}

        {promoCode && (
          <div className="text-center text-pink-600 mt-5">
            <h4 className="poppins-semibold text-lg underline">
              Félicitations! Vous avez gagné un code promo:
            </h4>
            <p className="text-gray-700 text-lg">{promoCode}</p>
          </div>
        )}

        <p className="text-center text-gray-700 mt-5">
          Nombre de filleuls: {referrals.length} utilisateurs
        </p>

        <div className="overflow-x-auto mt-5">
          <table className="table table-xs">
            <thead className="text-center bg-pink-600 text-white">
              <tr>
                <th class="py-1 md:py-2 px-2 sm:px-4 md:px-6 text-xs sm:text-sm md:text-base">
                  Email
                </th>
                <th class="py-1 md:py-2 px-2 sm:px-4 md:px-6 text-xs sm:text-sm md:text-base">
                  Date d'inscription
                </th>
                <th class="py-1 md:py-2 px-2 sm:px-4 md:px-6 text-xs sm:text-sm md:text-base">
                  De
                </th>
              </tr>
            </thead>
            <tbody className="text-center">
              {referrals.map((referral, index) => (
                <tr key={index}>
                  <td class="py-1 md:py-2 px-2 sm:px-4 md:px-6 text-xs sm:text-sm md:text-base text-gray-800">
                    {referral.email}
                  </td>
                  <td class="py-1 md:py-2 px-2 sm:px-4 md:px-6 text-xs sm:text-sm md:text-base text-gray-800">
                    {referral.dateCreated}
                  </td>
                  <td class="py-1 md:py-2 px-2 sm:px-4 md:px-6 text-xs sm:text-sm md:text-base text-gray-800">
                    {window.location.origin}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default Parrainage;
